export const isEditableTableAddNewIndex = (index: number, isAddNew: boolean) => isAddNew && index === 0
